var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('kam-read-only-form',{attrs:{"title":"KAM formulier","answers":_vm.answers,"media":_vm.media}})
}
var staticRenderFns = []

export { render, staticRenderFns }